// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__A4ytT","rotation":"spinner_rotation__qJNb+"};